// Vue
import { Component, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

// Services
import { Api } from "#/api";
import { KatalogData } from "#/common/models/katalog_data/KatalogData";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class PfKatalogAufbaurichtlinienModule extends ModuleBase {
  private data: KatalogData | null = null;
  private filter: object = {};
  private session: object = {};

  private selectedFiles: string[] = [];

  @Watch("filter", { deep: true })
  onFilterChange() {
    this.loadData();
  }

  public created() {
    this.initialize();
  }

  public async initialize() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("token")) {
      let token = urlParams.get("token")!;

      this.session = await Api.katalogService.getSession(token);
      this.data = await Api.katalogService.getData(
        this.session["klasse"],
        this.instance["katalog"],
        this.session["completeFilter"] || {},
        {},
        token
      );
    }
  }

  public async loadData() {
    const urlParams = new URLSearchParams(window.location.search);
    let token = urlParams.get("token")!;

    this.data = await Api.katalogService.getData(
      this.session["klasse"],
      this.instance["katalog"],
      this.session["completeFilter"] || {},
      this.filter,
      token || undefined
    );
  }

  get languageSelect() {
    return this.data && this.data.hasOwnProperty("selects")
      ? [this.data.selects["SPRACHE"]]
      : null;
  }

  public getBackgroundColorFromInstance(instance: object) {
    return "white";
  }

  onResetFilter(key) {
    if (this.filter[key]) {
      delete this.filter[key];
      this.resetSelectedFiles();
      this.onFilterChange();
    }
  }

  resetSelectedFiles() {
    this.selectedFiles = [];
  }

  public onDownloadSelectedItems(event) {
    window.location.href = Api.katalogService.getDownloadFilesUrl(
      this.session["klasse"],
      this.selectedFiles
    );
  }
}
